import CASL from '@/utils/constants/casl'

export default [
  {
    path: 'add-point',
    name: 'loyalty.add-point',
    meta: {
      title: 'Add Point List',
      action: 'read',
      subject: CASL.ACCESS.ADD_POINT
    },
    component: () => import('./list/AddPointListPage.vue')
  },
  {
    path: 'add-point/add',
    name: 'loyalty.add-point.add',
    meta: {
      title: 'Add Point',
      action: 'create',
      subject: CASL.ACCESS.ADD_POINT
    },
    component: () => import('./form/AddPointFormPage.vue')
  }
]
